(function () {
  var root = document.getElementById("nfc-products");
  var view = document.getElementById("nfcProductView");
  if (!root || !view) return;

  var thumbsEl = view.querySelector("[data-nfc-thumbs]");
  var mainEl = view.querySelector("[data-nfc-main]");
  var slideIndex = 0;
  var slideUrls = [];
  var logoObjectUrl = null;
  var imageObjectUrl = null;

  function qs(sel) {
    return view.querySelector(sel);
  }

  function setText(sel, text) {
    var el = qs(sel);
    if (!el) return;
    el.textContent = text || "";
    if (el.hidden !== undefined && sel !== "[data-nfc-view-badge]") {
      el.hidden = !text;
    }
  }

  function setMainImage(url, title, index) {
    if (!mainEl) return;
    if (!url) {
      mainEl.innerHTML = '<div class="nfc-pdp__placeholder"><span>' + (title || "Product") + "</span></div>";
      return;
    }
    mainEl.innerHTML =
      '<img src="' +
      url +
      '" alt="' +
      (title || "Product") +
      " — image " +
      (index + 1) +
      '" loading="lazy">';
  }

  function buildGallery(urls, title) {
    slideUrls = urls.length ? urls : [];
    thumbsEl.innerHTML = "";
    slideIndex = 0;

    if (!slideUrls.length) {
      thumbsEl.hidden = true;
      setMainImage("", title, 0);
      toggleArrows(false);
      return;
    }

    thumbsEl.hidden = false;
    slideUrls.forEach(function (url, i) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "nfc-pdp__thumb" + (i === 0 ? " is-active" : "");
      btn.setAttribute("aria-label", "Show image " + (i + 1));
      btn.dataset.nfcThumb = String(i);
      btn.innerHTML = '<img src="' + url + '" alt="" loading="lazy">';
      thumbsEl.appendChild(btn);
    });

    setMainImage(slideUrls[0], title, 0);
    toggleArrows(slideUrls.length > 1);
  }

  function toggleArrows(show) {
    var prev = view.querySelector("[data-nfc-slide-prev]");
    var next = view.querySelector("[data-nfc-slide-next]");
    if (prev) prev.hidden = !show;
    if (next) next.hidden = !show;
  }

  function goSlide(i) {
    if (!slideUrls.length) return;
    slideIndex = (i + slideUrls.length) % slideUrls.length;
    var title = qs("[data-nfc-view-title]");
    var name = title ? title.textContent : "Product";
    setMainImage(slideUrls[slideIndex], name, slideIndex);
    thumbsEl.querySelectorAll(".nfc-pdp__thumb").forEach(function (btn, idx) {
      btn.classList.toggle("is-active", idx === slideIndex);
    });
  }

  function customizationEnabled() {
    return view.dataset.nfcCustomizationEnabled === "1";
  }

  function setCustomizationEnabled(enabled) {
    view.dataset.nfcCustomizationEnabled = enabled ? "1" : "0";
    var panel = qs("[data-nfc-custom-panel]");
    if (panel) panel.hidden = !enabled;
    view.classList.toggle("nfc-pdp--custom-on", enabled);
    if (enabled) {
      setCustomImageEnabled(view.dataset.nfcCardCustomImage === "1");
      initCustomPanel();
    } else {
      setCustomImageEnabled(false);
    }
  }

  function cleanLines(arr) {
    if (!arr || !arr.length) return [];
    return arr.map(function (s) {
      return String(s || "").trim();
    }).filter(Boolean);
  }

  var FEATURE_ICONS = [
    "fa-headset",
    "fa-shield-halved",
    "fa-wifi",
    "fa-mobile-screen",
    "fa-pen-fancy",
    "fa-qrcode",
    "fa-comments",
    "fa-bolt",
  ];

  function parseFeatureLine(line) {
    var parts = line.split("|");
    if (parts.length < 2) return { title: line.trim(), desc: "" };
    return { title: parts[0].trim(), desc: parts.slice(1).join("|").trim() };
  }

  /** Split lines where multiple Title | desc pairs were pasted on one row. */
  function expandPipeCardLines(lines) {
    var out = [];
    lines.forEach(function (line) {
      var parts = String(line || "")
        .split("|")
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean);
      if (parts.length <= 2) {
        out.push(line);
        return;
      }
      for (var i = 0; i < parts.length; i += 2) {
        if (parts[i + 1]) out.push(parts[i] + " | " + parts[i + 1]);
        else out.push(parts[i]);
      }
    });
    return out;
  }

  function expandStepLines(lines) {
    if (!lines.length) return lines;
    if (lines.length > 1) return lines;
    var one = lines[0];
    if (one.indexOf("\n") >= 0) {
      return one
        .split(/\r?\n/)
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean);
    }
    return lines;
  }

  function createFeatureCard(title, desc, index, dark) {
    var card = document.createElement("article");
    card.className = "nfc-pdp__feat-card" + (dark ? " nfc-pdp__feat-card--dark" : "");
    var icon = document.createElement("span");
    icon.className = "nfc-pdp__feat-icon";
    icon.setAttribute("aria-hidden", "true");
    var i = document.createElement("i");
    i.className = "fas " + (FEATURE_ICONS[index % FEATURE_ICONS.length] || "fa-star");
    icon.appendChild(i);
    var h = document.createElement("h4");
    h.textContent = title;
    var p = document.createElement("p");
    p.textContent = desc;
    card.appendChild(icon);
    card.appendChild(h);
    if (desc) card.appendChild(p);
    return card;
  }

  function createDeliveryCard(lines, dark) {
    var card = document.createElement("article");
    card.className = "nfc-pdp__delivery-card" + (dark ? " nfc-pdp__delivery-card--dark" : "");
    if (!lines.length) return card;
    var icon = document.createElement("span");
    icon.className = "nfc-pdp__delivery-icon";
    icon.setAttribute("aria-hidden", "true");
    var i = document.createElement("i");
    i.className = "fas " + (dark ? "fa-clock" : "fa-truck");
    icon.appendChild(i);
    var h = document.createElement("h4");
    h.textContent = lines[0];
    card.appendChild(icon);
    card.appendChild(h);
    if (lines.length > 1) {
      var ul = document.createElement("ul");
      lines.slice(1).forEach(function (line) {
        var li = document.createElement("li");
        li.textContent = line;
        ul.appendChild(li);
      });
      card.appendChild(ul);
    }
    return card;
  }

  function populatePdpExtras(card) {
    var extrasRoot = qs("[data-nfc-pdp-extras]");
    var data = {
      material: {},
      featureCards: [],
      how: [],
      deliveryStandard: [],
      deliveryExpress: [],
      included: [],
    };

    var script = card.querySelector("[data-nfc-card-extras]");
    if (script) {
      try {
        data = JSON.parse(script.textContent);
      } catch (e) {
        data = { material: {}, featureCards: [], how: [], deliveryStandard: [], deliveryExpress: [], included: [] };
      }
    }

    var productTitle = card.getAttribute("data-nfc-title") || "";
    var mat = data.material || {};
    var matWrap = qs("[data-nfc-material-wrap]");
    var matLabel = qs("[data-nfc-material-label]");
    var matTitle = qs("[data-nfc-material-title]");
    var matDesc = qs("[data-nfc-material-desc]");
    var matBadge = qs("[data-nfc-material-badge]");
    var matBadgeText = qs("[data-nfc-material-badge-text]");
    var titleText = mat.title || productTitle;
    var descText = mat.desc || "";

    if (matWrap && (titleText || descText)) {
      if (matLabel) matLabel.textContent = mat.label || "BUILD TYPE";
      if (matTitle) matTitle.textContent = titleText;
      if (matDesc) matDesc.textContent = descText;
      if (matBadge && matBadgeText) {
        if (mat.badge) {
          matBadgeText.textContent = mat.badge;
          matBadge.hidden = false;
        } else {
          matBadge.hidden = true;
        }
      }
      matWrap.hidden = false;
    } else if (matWrap) {
      matWrap.hidden = true;
    }

    var featSection = qs("[data-nfc-features-section]");
    var featGrid = qs("[data-nfc-features-grid]");
    var featTitle = qs("[data-nfc-features-title]");
    var featSub = qs("[data-nfc-features-sub]");
    var featureLines = expandPipeCardLines(cleanLines(data.featureCards));

    if (featTitle && data.featuresTitle) featTitle.textContent = data.featuresTitle;
    if (featSub && data.featuresSub) featSub.textContent = data.featuresSub;

    if (featGrid) {
      featGrid.innerHTML = "";
      featureLines.forEach(function (line, idx) {
        var f = parseFeatureLine(line);
        featGrid.appendChild(createFeatureCard(f.title, f.desc, idx, idx === 0));
      });
    }
    if (featSection) featSection.hidden = !featureLines.length;

    var howWrap = qs("[data-nfc-how-wrap]");
    var howGrid = qs("[data-nfc-how-grid]");
    var how = expandStepLines(cleanLines(data.how));
    if (howGrid) {
      howGrid.innerHTML = "";
      how.forEach(function (step, idx) {
        howGrid.appendChild(createFeatureCard(step, "", idx, idx === 0));
      });
    }
    if (howWrap) howWrap.hidden = !how.length;

    var delWrap = qs("[data-nfc-delivery-wrap]");
    var delGrid = qs("[data-nfc-delivery-grid]");
    var std = cleanLines(data.deliveryStandard);
    var exp = cleanLines(data.deliveryExpress);
    if (delGrid) {
      delGrid.innerHTML = "";
      if (std.length) delGrid.appendChild(createDeliveryCard(std, false));
      if (exp.length) delGrid.appendChild(createDeliveryCard(exp, true));
    }
    if (delWrap) delWrap.hidden = !std.length && !exp.length;

    var includedWrap = qs("[data-nfc-included-wrap]");
    var includedList = qs("[data-nfc-included-list]");
    var included = cleanLines(data.included);
    if (includedList) {
      includedList.innerHTML = "";
      included.forEach(function (item) {
        var li = document.createElement("li");
        li.textContent = item;
        includedList.appendChild(li);
      });
    }
    if (includedWrap) includedWrap.hidden = !included.length;

    var hasExtras =
      (includedWrap && !includedWrap.hidden) ||
      (matWrap && !matWrap.hidden) ||
      (featSection && !featSection.hidden) ||
      (howWrap && !howWrap.hidden) ||
      (delWrap && !delWrap.hidden);
    if (extrasRoot) extrasRoot.hidden = !hasExtras;
  }

  function initCustomPanel() {
    if (!customizationEnabled()) return;
    var panel = qs("[data-nfc-custom-panel]");
    if (panel) panel.classList.add("is-open");
    view.classList.add("nfc-pdp--custom-on");
    updatePreview();
  }

  function revokeLogoUrl() {
    if (logoObjectUrl) {
      URL.revokeObjectURL(logoObjectUrl);
      logoObjectUrl = null;
    }
  }

  function revokeImageUrl() {
    if (imageObjectUrl) {
      URL.revokeObjectURL(imageObjectUrl);
      imageObjectUrl = null;
    }
  }

  function revokePreviewUrls() {
    revokeLogoUrl();
    revokeImageUrl();
  }

  var ADORIX_DEMO_QR = "https://adorix.shop/pages/nfc";

  var NFC_FONT_STACKS = {
    Montserrat: '"Montserrat", sans-serif',
    Cinzel: '"Cinzel", serif',
    "Dancing Script": '"Dancing Script", cursive',
    "Great Vibes": '"Great Vibes", cursive',
    Pacifico: '"Pacifico", cursive',
    "Playfair Display": '"Playfair Display", serif',
    Oswald: '"Oswald", sans-serif',
    "Bebas Neue": '"Bebas Neue", sans-serif',
    Roboto: '"Roboto", sans-serif',
    Merriweather: '"Merriweather", serif',
  };

  var NFC_CURSIVE_FONTS = ["Dancing Script", "Great Vibes", "Pacifico"];

  function applyFrontFont(el, fontKey) {
    var stack = NFC_FONT_STACKS[fontKey] || NFC_FONT_STACKS.Montserrat;
    var live = qs("[data-nfc-card-live]");
    var cursive = NFC_CURSIVE_FONTS.indexOf(fontKey) >= 0;
    if (live) live.style.setProperty("--nfc-preview-font", stack);
    if (!el) return;
    el.style.setProperty("font-family", stack, "important");
    el.setAttribute("data-preview-font", fontKey || "Montserrat");
    el.classList.toggle("is-cursive", cursive);
  }

  function targetFontSize(len, cursive) {
    var max = cursive ? 22 : 26;
    var softMin = cursive ? 12 : 13;
    if (len <= 6) return max;
    if (len <= 12) return Math.round(max - (len - 6) * 0.7);
    if (len <= 18) return Math.round(max - 4.2 - (len - 12) * 0.6);
    if (len <= 26) return Math.round(max - 7.8 - (len - 18) * 0.5);
    if (len <= 36) return Math.round(max - 11.8 - (len - 26) * 0.4);
    return softMin;
  }

  function letterSpacingForLen(len, cursive) {
    if (cursive) return "0.02em";
    if (len <= 10) return "0.1em";
    if (len <= 18) return "0.08em";
    if (len <= 26) return "0.06em";
    return "0.045em";
  }

  function measureFit(el, maxW, sizePx) {
    el.style.setProperty("font-size", sizePx + "px", "important");
    return el.scrollWidth <= maxW;
  }

  function fitPreviewText(el, text, fontKey) {
    if (!el) return;
    var display = text || "Your Name";
    var key = fontKey || "Montserrat";
    var cursive = NFC_CURSIVE_FONTS.indexOf(key) >= 0;
    var len = display.length;
    el.textContent = display;
    applyFrontFont(el, key);

    var box = el.parentElement;
    var maxW = box && box.clientWidth ? box.clientWidth - 8 : 220;
    var hardMin = cursive ? 10 : 11;
    var target = targetFontSize(len, cursive);

    el.style.setProperty("white-space", "nowrap", "important");
    el.style.setProperty("display", "block", "important");
    el.style.setProperty("margin", "0 auto", "important");
    el.style.setProperty("width", "max-content", "important");
    el.style.setProperty("max-width", "none", "important");
    el.style.setProperty("overflow", "visible", "important");
    el.style.removeProperty("text-overflow");
    el.style.setProperty("letter-spacing", letterSpacingForLen(len, cursive), "important");
    el.style.setProperty("transform", "none", "important");

    var best = target;
    if (!measureFit(el, maxW, target)) {
      var lo = hardMin;
      var hi = target;
      best = hardMin;
      while (lo <= hi) {
        var mid = Math.floor((lo + hi) / 2);
        if (measureFit(el, maxW, mid)) {
          best = mid;
          lo = mid + 1;
        } else {
          hi = mid - 1;
        }
      }
    }

    el.style.setProperty("font-size", best + "px", "important");

    if (el.scrollWidth > maxW) {
      var scale = Math.max(0.9, maxW / el.scrollWidth);
      el.style.setProperty("transform", "scaleX(" + scale.toFixed(3) + ")", "important");
    }

    requestAnimationFrame(function () {
      if (!el.parentElement || el.textContent !== display) return;
      var w = el.parentElement.clientWidth - 8;
      if (w < 1) return;
      el.style.setProperty("font-size", best + "px", "important");
      if (el.scrollWidth <= w) {
        el.style.setProperty("transform", "none", "important");
        return;
      }
      var s = Math.max(0.9, w / el.scrollWidth);
      el.style.setProperty("transform", "scaleX(" + s.toFixed(3) + ")", "important");
    });
  }

  function customImageAllowed() {
    return view.dataset.nfcCustomImageEnabled === "1";
  }

  function setCustomImageEnabled(enabled) {
    view.dataset.nfcCustomImageEnabled = enabled ? "1" : "0";
    var opt = view.querySelector("[data-nfc-custom-image-opt]");
    var list = qs("[data-nfc-back-mode-list]");
    if (opt) opt.hidden = !enabled;
    if (list) {
      list.classList.toggle("nfc-pdp__back-mode--two", !enabled);
      list.classList.toggle("nfc-pdp__back-mode--three", enabled);
    }
    if (!enabled) {
      var imageInput = document.getElementById("nfcImageFile");
      if (imageInput) imageInput.value = "";
      revokeImageUrl();
      var current = view.querySelector('[data-nfc-back-mode][value="custom-image"]');
      if (current && current.checked) {
        var tap = view.querySelector('[data-nfc-back-mode][value="adorix-tap"]');
        if (tap) tap.checked = true;
      }
    }
    syncBackModeUi();
    updatePreview();
  }

  function getBackMode() {
    var r = view.querySelector("[data-nfc-back-mode]:checked");
    if (!r) return "adorix-tap";
    if (r.value === "custom-image" && !customImageAllowed()) return "adorix-tap";
    if (r.value === "custom-qr" || r.value === "custom-image") return r.value;
    return "adorix-tap";
  }

  function backTypeLabel(mode) {
    if (mode === "custom-qr") return "Custom QR or Logo";
    if (mode === "custom-image") return "Customized Image";
    return "Adorix Tap QR";
  }

  function syncBackModeUi() {
    var mode = getBackMode();
    var logoField = qs("[data-nfc-logo-field]");
    var imageField = qs("[data-nfc-image-field]");
    var typeProp = qs("[data-nfc-back-type-prop]");
    var hint = qs("[data-nfc-card-hint]");

    view.querySelectorAll(".nfc-pdp__back-mode-opt").forEach(function (lbl) {
      var inp = lbl.querySelector("[data-nfc-back-mode]");
      lbl.classList.toggle("is-active", inp && inp.checked);
    });

    if (logoField) logoField.hidden = mode !== "custom-qr";
    if (imageField) imageField.hidden = mode !== "custom-image";
    if (typeProp) typeProp.value = backTypeLabel(mode);
    if (hint) {
      if (mode === "custom-qr") hint.textContent = "Upload PNG logo or QR for back — preview updates live";
      else if (mode === "custom-image") {
        var feeCart = qs("[data-nfc-image-fee-cart]");
        var feeTxt = feeCart && feeCart.textContent.trim() ? feeCart.textContent.trim() : "250 TK";
        hint.textContent = "Upload customized back image (PNG) — extra " + feeTxt;
      }
      else hint.textContent = "Adorix Tap QR — one QR centered on back";
    }
  }

  function syncStackedScene() {
    /* Layout handled in CSS; scene uses overflow:hidden to clip cards */
  }

  function setCardSide(side) {
    var scene = qs("[data-nfc-card-scene]");
    if (!scene) return;
    side = side === "back" ? "back" : "front";
    scene.setAttribute("data-active-side", side);
    syncStackedScene();
    view.querySelectorAll("[data-nfc-card-side]").forEach(function (btn) {
      var active = btn.getAttribute("data-nfc-card-side") === side;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });
  }

  function updatePreview() {
    var textInput = document.getElementById("nfcCustomText");
    var font = document.getElementById("nfcCustomFont") || qs('[data-nfc-font="Custom Text Font"]');
    var frontText = qs("[data-nfc-preview-text]");
    var qrImg = qs("[data-nfc-preview-qr-img]");
    var logoImg = qs("[data-nfc-preview-logo-img]");
    var live = qs("[data-nfc-card-live]");
    var logoInput = document.getElementById("nfcLogoFile");
    var imageInput = document.getElementById("nfcImageFile");
    var logoFile = logoInput && logoInput.files && logoInput.files[0];
    var imageFile = imageInput && imageInput.files && imageInput.files[0];
    var imageImg = qs("[data-nfc-preview-image-img]");
    var txt = textInput && textInput.value.trim() ? textInput.value.trim() : "";
    var mode = getBackMode();

    syncBackModeUi();

    if (live) live.classList.add("is-live");

    if (frontText) {
      fitPreviewText(frontText, txt, font ? font.value : "Montserrat");
    }

    var backCard = qs('[data-nfc-card-face="back"]');

    if (mode !== "custom-qr") {
      revokeLogoUrl();
      if (logoImg) logoImg.innerHTML = "";
    }
    if (mode !== "custom-image") {
      revokeImageUrl();
      if (imageImg) imageImg.innerHTML = "";
    }

    if (mode === "adorix-tap") {
      if (backCard) backCard.setAttribute("data-back-display", "tap");
      if (qrImg) {
        qrImg.src =
          "https://api.qrserver.com/v1/create-qr-code/?size=220x220&margin=2&color=1a1a1a&bgcolor=ffffff&data=" +
          encodeURIComponent(ADORIX_DEMO_QR);
      }
    } else if (mode === "custom-qr") {
      if (logoFile && logoImg) {
        if (backCard) backCard.setAttribute("data-back-display", "custom-filled");
        revokeLogoUrl();
        logoObjectUrl = URL.createObjectURL(logoFile);
        logoImg.innerHTML = '<img src="' + logoObjectUrl + '" alt="">';
      } else {
        if (backCard) backCard.setAttribute("data-back-display", "custom");
        if (logoImg) logoImg.innerHTML = "";
      }
    } else if (mode === "custom-image") {
      if (imageFile && imageImg) {
        if (backCard) backCard.setAttribute("data-back-display", "image-filled");
        revokeImageUrl();
        imageObjectUrl = URL.createObjectURL(imageFile);
        imageImg.innerHTML = '<img src="' + imageObjectUrl + '" alt="">';
      } else {
        if (backCard) backCard.setAttribute("data-back-display", "image");
        if (imageImg) imageImg.innerHTML = "";
      }
    }
  }

  function resetCustomForm() {
    view.querySelectorAll("[data-nfc-prop]").forEach(function (el) {
      el.value = "";
    });
    view.querySelectorAll("[data-nfc-font]").forEach(function (el) {
      el.selectedIndex = 0;
    });
    var logoFile = document.getElementById("nfcLogoFile");
    var imageFile = document.getElementById("nfcImageFile");
    if (logoFile) logoFile.value = "";
    if (imageFile) imageFile.value = "";
    var tap = view.querySelector('[data-nfc-back-mode][value="adorix-tap"]');
    if (tap) tap.checked = true;
    var qty = qs("[data-nfc-qty]");
    if (qty) qty.value = "1";
    revokePreviewUrls();
    initCustomPanel();
  }

  function setCheckoutState(variantId) {
    var btn = qs("[data-nfc-add-checkout]");
    var hint = qs("[data-nfc-checkout-hint]");
    view.dataset.nfcVariantId = variantId || "";
    var ok = !!variantId;
    if (btn) {
      btn.disabled = !ok;
      btn.setAttribute("aria-disabled", ok ? "false" : "true");
    }
    if (hint) hint.hidden = ok;
  }

  function openView(card, focusCustom) {
    var images = (card.getAttribute("data-nfc-images") || "")
      .split("|")
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);

    var badge = card.getAttribute("data-nfc-badge") || "";
    var badgeEl = qs("[data-nfc-view-badge]");
    if (badgeEl) {
      badgeEl.textContent = badge;
      badgeEl.hidden = !badge;
    }

    setText("[data-nfc-view-tag]", card.getAttribute("data-nfc-tagline"));
    setText("[data-nfc-view-title]", card.getAttribute("data-nfc-title"));
    setText("[data-nfc-view-desc]", card.getAttribute("data-nfc-desc"));
    setText("[data-nfc-view-price]", card.getAttribute("data-nfc-price"));

    var details = card.getAttribute("data-nfc-details") || "";
    var desc = card.getAttribute("data-nfc-desc") || "";
    var wrap = qs("[data-nfc-view-details-wrap]");
    var detailsEl = qs("[data-nfc-view-details]");
    if (wrap && detailsEl) {
      var show = details && details !== desc;
      detailsEl.textContent = show ? details : "";
      wrap.hidden = !show;
    }

    var featEl = qs("[data-nfc-view-features]");
    if (featEl) {
      featEl.innerHTML = "";
      (card.getAttribute("data-nfc-features") || "").split(",").forEach(function (f) {
        f = f.trim();
        if (!f) return;
        var li = document.createElement("li");
        li.textContent = f;
        featEl.appendChild(li);
      });
      featEl.hidden = !featEl.children.length;
    }

    var buyBtn = qs("[data-nfc-add-checkout]");
    if (buyBtn) buyBtn.textContent = "Order now — checkout";

    setCheckoutState(card.getAttribute("data-nfc-variant-id") || "");

    var sectionAddon = view.getAttribute("data-nfc-image-addon-variant") || "";
    var cardAddon = card.getAttribute("data-nfc-image-addon-variant") || "";
    view.dataset.nfcImageAddonVariant = cardAddon || sectionAddon;

    var wa = qs("[data-nfc-view-wa]");
    if (wa && card.getAttribute("data-nfc-title")) {
      var msg = encodeURIComponent("I want to order: " + card.getAttribute("data-nfc-title"));
      var base = wa.getAttribute("href").split("?")[0];
      wa.href = base + "?text=" + msg;
    }

    resetCustomForm();
    setCardSide("front");
    syncStackedScene();
    buildGallery(images, card.getAttribute("data-nfc-title"));

    var productTitle = card.getAttribute("data-nfc-title") || "";
    var nameProp = qs("[data-nfc-product-name-prop]");
    if (nameProp) nameProp.value = productTitle;
    var customProd = qs("[data-nfc-custom-product]");
    if (customProd) {
      customProd.textContent = productTitle ? "Selected product: " + productTitle : "";
      customProd.hidden = !productTitle;
    }

    view.dataset.nfcCardCustomImage = card.getAttribute("data-nfc-enable-custom-image") || "0";
    setCustomizationEnabled(card.getAttribute("data-nfc-enable-customization") !== "0");
    populatePdpExtras(card);

    view.hidden = false;
    view.setAttribute("aria-hidden", "false");
    document.body.classList.add("nfc-product-view-open");
    window.scrollTo(0, 0);

    if (focusCustom && customizationEnabled()) {
      window.setTimeout(function () {
        var panel = qs("[data-nfc-custom-panel]");
        if (panel) panel.scrollIntoView({ behavior: "smooth", block: "start" });
        var firstInput = document.getElementById("nfcCustomText");
        if (firstInput) firstInput.focus({ preventScroll: true });
      }, 120);
    }
  }

  function closeView() {
    view.hidden = true;
    view.setAttribute("aria-hidden", "true");
    document.body.classList.remove("nfc-product-view-open");
    revokePreviewUrls();
  }

  function changeQty(delta) {
    var input = qs("[data-nfc-qty]");
    if (!input) return;
    var n = Math.min(20, Math.max(1, (parseInt(input.value, 10) || 1) + delta));
    input.value = String(n);
  }

  function appendCartItemProps(fd, itemIndex, props) {
    Object.keys(props).forEach(function (key) {
      var val = props[key];
      if (!key || val == null || val === "") return;
      if (val instanceof File) {
        fd.append("items[" + itemIndex + "][properties][" + key + "]", val);
      } else {
        fd.append("items[" + itemIndex + "][properties][" + key + "]", String(val));
      }
    });
  }

  function buildMainLineProperties(mode) {
    var props = {};

    view.querySelectorAll("[data-nfc-prop]").forEach(function (el) {
      var key = el.getAttribute("data-nfc-prop");
      var val = el.value.trim();
      if (key && val) props[key] = val;
    });
    view.querySelectorAll("[data-nfc-font]").forEach(function (el) {
      var key = el.getAttribute("data-nfc-font");
      if (key && el.value) props[key] = el.value;
    });

    if (mode === "custom-qr") {
      var fileInput = document.getElementById("nfcLogoFile");
      if (fileInput && fileInput.files && fileInput.files[0]) {
        var file = fileInput.files[0];
        if (file.type !== "image/png" && !/\.png$/i.test(file.name)) {
          throw new Error("Logo must be a PNG file with transparent background.");
        }
        props["Logo File"] = file;
      }
    } else if (mode === "custom-image") {
      var imgInput = document.getElementById("nfcImageFile");
      if (imgInput && imgInput.files && imgInput.files[0]) {
        var img = imgInput.files[0];
        if (img.type !== "image/png" && !/\.png$/i.test(img.name)) {
          throw new Error("Back image must be a PNG file.");
        }
        props["Custom Back Image"] = img;
      }
      var feeCart = qs("[data-nfc-image-fee-cart]");
      if (feeCart && feeCart.textContent.trim()) {
        props["Custom Back Image Fee"] = feeCart.textContent.trim();
      }
    }

    props.Customization = "Yes — text & back QR";
    return props;
  }

  function addToCheckout() {
    var variantId = view.dataset.nfcVariantId;
    if (!variantId) {
      alert("Theme Editor → NFC Products block → select a Shopify product for checkout.");
      return;
    }

    var qtyInput = qs("[data-nfc-qty]");
    var qty = Math.max(1, Math.min(20, parseInt(qtyInput && qtyInput.value, 10) || 1));
    var mode = getBackMode();
    var mainProps = {};

    if (customizationEnabled()) {
      try {
        mainProps = buildMainLineProperties(mode);
      } catch (err) {
        alert(err.message);
        return;
      }
    } else {
      var nameProp = qs("[data-nfc-product-name-prop]");
      if (nameProp && nameProp.value.trim()) mainProps["NFC Product"] = nameProp.value.trim();
    }

    var cartItems = [{ id: variantId, quantity: qty, properties: mainProps }];

    if (customizationEnabled() && mode === "custom-image" && customImageAllowed()) {
      var addonVariantId = view.dataset.nfcImageAddonVariant;
      if (addonVariantId) {
        var feeLabel = (mainProps["Custom Back Image Fee"] || "250 TK").trim();
        cartItems.push({
          id: addonVariantId,
          quantity: qty,
          properties: {
            "Add-on": "Custom back image",
            Fee: feeLabel,
          },
        });
      } else {
        alert(
          "Customized image fee is noted on the order but ৳250 is not added automatically.\n\nTheme Editor → NFC Products → select “Customized image fee product (checkout)” — a ৳250 product."
        );
      }
    }

    var fd = new FormData();
    cartItems.forEach(function (item, i) {
      fd.append("items[" + i + "][id]", String(item.id));
      fd.append("items[" + i + "][quantity]", String(item.quantity));
      if (item.properties) appendCartItemProps(fd, i, item.properties);
    });

    var btn = qs("[data-nfc-add-checkout]");
    var label = btn ? btn.textContent : "Order now — checkout";
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Adding to cart…";
    }

    fetch("/cart/add.js", { method: "POST", body: fd, credentials: "same-origin" })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || "Could not add to cart");
          window.location.href = "/checkout";
        });
      })
      .catch(function (err) {
        alert(err.message || "Could not checkout. Try WhatsApp or contact support.");
        if (btn) {
          btn.disabled = false;
          btn.textContent = label;
        }
      });
  }

  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-nfc-order-link]")) return;
    var open = e.target.closest("[data-nfc-open-view]");
    var card = e.target.closest("[data-nfc-product-card]");
    if (open && card) {
      e.preventDefault();
      openView(card, !!e.target.closest("[data-nfc-focus-custom]"));
    }
  });

  root.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var open = e.target.closest("[data-nfc-open-view]");
    if (!open) return;
    e.preventDefault();
    var card = e.target.closest("[data-nfc-product-card]");
    if (card) openView(card, !!open.closest("[data-nfc-focus-custom]"));
  });

  view.addEventListener("click", function (e) {
    if (e.target.closest("[data-nfc-view-close]")) closeView();
    if (e.target.closest("[data-nfc-thumb]")) goSlide(parseInt(e.target.closest("[data-nfc-thumb]").dataset.nfcThumb, 10));
    if (e.target.closest("[data-nfc-slide-prev]")) goSlide(slideIndex - 1);
    if (e.target.closest("[data-nfc-slide-next]")) goSlide(slideIndex + 1);
    if (e.target.closest("[data-nfc-qty-minus]")) changeQty(-1);
    if (e.target.closest("[data-nfc-qty-plus]")) changeQty(1);
    if (e.target.closest("[data-nfc-add-checkout]")) {
      e.preventDefault();
      addToCheckout();
    }
    var sideTab = e.target.closest("[data-nfc-card-side]");
    if (sideTab) {
      e.preventDefault();
      setCardSide(sideTab.getAttribute("data-nfc-card-side"));
    }
  });

  view.addEventListener("change", function (e) {
    if (e.target.matches("[data-nfc-back-mode]")) {
      syncBackModeUi();
      updatePreview();
      setCardSide("back");
    }
    if (e.target.matches("[data-nfc-prop], [data-nfc-font], #nfcCustomFont, #nfcLogoFile, #nfcImageFile")) updatePreview();
  });

  view.addEventListener("input", function (e) {
    if (e.target.matches("#nfcCustomText, #nfcCustomFont, [data-nfc-prop], [data-nfc-font]")) updatePreview();
  });

  document.addEventListener("keydown", function (e) {
    if (view.hidden) return;
    if (e.key === "Escape") closeView();
    if (e.key === "ArrowLeft") goSlide(slideIndex - 1);
    if (e.key === "ArrowRight") goSlide(slideIndex + 1);
  });

  window.addEventListener("resize", function () {
    syncStackedScene();
    if (!view.hidden) updatePreview();
  });
  syncStackedScene();

  var touchStartX = 0;
  var stage = view.querySelector(".nfc-pdp__stage");
  if (stage) {
    stage.addEventListener(
      "touchstart",
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    stage.addEventListener(
      "touchend",
      function (e) {
        var dx = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(dx) < 40) return;
        goSlide(dx < 0 ? slideIndex + 1 : slideIndex - 1);
      },
      { passive: true }
    );
  }
})();
